// GENERATED FILE, DO NOT MANUALLY EDIT
import { html } from '@horizon/base';
import { HznIconBase } from '../../icon/icon-base.js';
import './types.js';
/**
 *
 * @tag hzn-icon-sign-arrow-right
 * @tagname hzn-icon-sign-arrow-right
 * @summary An individual icon for Horizon
 */
export class HznIconSignArrowRight extends HznIconBase {
    render() {
        return html `<div class="hzn-icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M12.7072 2.29289C12.3167 1.90237 11.6835 1.90237 11.293 2.29289L2.29289 11.293C1.90237 11.6835 1.90237 12.3167 2.29289 12.7072L11.293 21.7073C11.6835 22.0978 12.3167 22.0978 12.7072 21.7073L21.7073 12.7072C22.0978 12.3167 22.0978 11.6835 21.7073 11.293L12.7072 2.29289ZM4.41421 12.0001L12.0001 4.41421L19.586 12.0001L12.0001 19.586L4.41421 12.0001ZM11.9538 8.74136L13.2125 10.0001L9.00011 10.0001C8.73489 10.0001 8.48054 10.1055 8.293 10.293C8.10546 10.4806 8.00011 10.7349 8.00011 11.0001V15.0001H10.0001V12.0001L12.9075 12.0001L11.9538 12.9539L13.368 14.3681L16.1814 11.5547C16.5719 11.1642 16.5719 10.531 16.1814 10.1405L13.368 7.32715L11.9538 8.74136Z" fill="currentColor"></path>
</svg></div>`;
    }
}
//# sourceMappingURL=sign-arrow-right.js.map